import type { InputHTMLAttributes, ReactNode } from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: ReactNode;
  error?: ReactNode;
}

export function Field({ label, hint, error, id, className = "", ...rest }: FieldProps) {
  const fieldId = id ?? `field-${label.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={fieldId} className="font-text text-[15px] text-granite-700 dark:text-granite-200">
        {label}
      </label>
      <input
        id={fieldId}
        className={`min-h-[48px] px-3 rounded-[var(--radius-control)] border text-[17px] font-text
          bg-white dark:bg-granite-900 text-granite-800 dark:text-granite-100
          border-granite-300 dark:border-granite-600
          placeholder:text-granite-400 focus:border-blaze
          ${error ? "border-blaze" : ""} ${className}`}
        {...rest}
      />
      {hint && !error && <p className="font-text text-[13px] text-granite-500">{hint}</p>}
      {error && <p className="font-text text-[13px] text-blaze" role="alert">{error}</p>}
    </div>
  );
}
